import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import { useRealmApp } from "../RealmApp";
import { useDatesContext } from "context/DatesContext";

const useClockSessions = (storeId, start, end, userId) => {
  const app = useRealmApp();
  const { clockSessions, loading } = useAllClockSessions(
    app.currentUser.id,
    storeId,
    start,
    end,
    userId
  );
  return {
    loading,
    clockSessions,
  };
};

export const useClockSessionById = (_id) => {
  return useAllClockSessionById(_id);
};

export default useClockSessions;

function useAllClockSessions(ownerId, storeId, start, end, userId) {
  const clockSessionDateInput = {
    storeId,
    start,
    end,
    userId,
  };
  const { getCacheControl } = useDatesContext();
  const fetchPolicy = getCacheControl("useAllClockSessions", 60 * 1000);
  //
  const { data, loading, error } = useQuery(
    gql`
      query GetClockSessionDate(
        $clockSessionDateInput: ClockSessionDateInput!
      ) {
        clockSessionDate(input: $clockSessionDateInput) {
          _id
          userId
          storeId
          status
          type
          chainId
          sessionStart
          sessionEnd
          sessionDuration
          notes
          updated
          updateDatetime
          creationDatetime
        }
      }
    `,
    { variables: { clockSessionDateInput }, fetchPolicy }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const clockSessions = data?.clockSessionDate ?? [];
  return { clockSessions, loading };
}

function useAllClockSessionById(_id) {
  const variables = {
    _id,
  };
  //
  const { data, loading, error } = useQuery(
    gql`
      query GetClockSession($_id: ObjectId!) {
        clockSession(query: { _id: $_id }) {
          _id
          userId
          storeId
          status
          type
          chainId
          sessionStart
          sessionEnd
          sessionDuration
          notes
          updated
          updateDatetime
          creationDatetime
        }
      }
    `,
    {
      variables,
      // skip if no id was provided
      skip: !_id,
    }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const clockSession = data?.clockSession ?? undefined;
  return { clockSession, loading };
}
